import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { App } from '../models/app.model';

@Injectable({
  providedIn: 'root',
})
export class SideBarMenuService {
  private linkClickedSource = new Subject<void>();
  linkClicked$ = this.linkClickedSource.asObservable();

  private clearSource = new Subject<void>();
  clearSource$ = this.clearSource.asObservable();

  onLinkClicked(app: App) {
    localStorage.setItem('appId', app.id);
    localStorage.setItem('appName', app.name);
    this.linkClickedSource.next();
  }

  clearSessionStorage() {
    localStorage.clear();
    this.clearSource.next();
  }
}
